module.exports = __webpack_public_path__ + "static/lathander-DND3_FnP-509b5fd79fee16eb00394d45b6d299e5.webp";